// Reference: https://github.com/prisma-labs/graphql-request/issues/103#issuecomment-866646237
const createFetchWithTimeout = (timeout: number) => async (input: RequestInfo, init?: RequestInit) => {
  const controller = new AbortController()

  const timerId = setTimeout(() => {
    controller.abort()
  }, timeout)

  try {
    return await fetch(input, { ...init, signal: controller.signal })
  } finally {
    clearTimeout(timerId)
  }
}

export default createFetchWithTimeout
